import { createSelector } from 'reselect';

const DEFAULT_STAFF_STATE = {
    loading: false,
    staffMembers: [],
    pendingInvites: [],
    searchTerm: '',
    error: null,
    isUploadingLogo: false,
    isUploadingPhoto: false,
};

const getStaffState = (state) => state.staff || DEFAULT_STAFF_STATE;

export const getStaffMembers = createSelector(
    [getStaffState],
    (staff) => staff.staffMembers
);

export const getStaffLoading = createSelector(
    [getStaffState],
    (staff) => staff.loading
);

export const getStaffSearchTerm = createSelector(
    [getStaffState],
    (staff) => staff.searchTerm
);

export const getStaffError = createSelector(
    [getStaffState],
    (staff) => staff.error
);

export const getPendingInvites = createSelector(
    [getStaffState],
    (staff) => staff.pendingInvites
);

export const getFilteredStaffMembers = createSelector(
    [getStaffMembers, getStaffSearchTerm],
    (staffMembers, searchTerm) => {
        if (!searchTerm) return staffMembers;
        
        const lowercaseSearch = searchTerm.toLowerCase();
        return staffMembers.filter(member => {
            const fullName = `${member.account?.firstName || ''} ${member.account?.lastName || ''}`.toLowerCase();
            const email = (member.account?.email || '').toLowerCase();
            return fullName.includes(lowercaseSearch) || email.includes(lowercaseSearch);
        });
    }
);

export const getIsUploadingLogo = createSelector(
    [getStaffState],
    (staff) => staff.isUploadingLogo
);

export const getIsUploadingPhoto = createSelector(
    [getStaffState],
    (staff) => staff.isUploadingPhoto
);
